import { api } from "./api";
import URI from "./URI";

export const getIYIPortfolio = () => {
  return api(
    URI.iyiPortfolio,
    {
      tokenRequired: true,
      method: "GET",
    },
    import.meta.env.VITE_REST_API_BASE
  );
};